import { PricingPage } from "@/components/pricing/pricing-page.tsx";
import { m } from "@/paraglide/messages.js";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { pageTitle } from "@/utils/page-title.ts";

export const Route = createFileRoute("/pricing")({
	beforeLoad: ({ context, location }) => {
		if (!context.auth.isAuthenticated) {
			throw redirect({
				to: "/auth/login",
				search: {
					redirect: location.href,
				},
			});
		}
	},
	head: () => ({
		meta: [
			{
				title: pageTitle(m.pricing_title()),
				description: m.pricing_subtitle(),
			},
		],
	}),
	component: PricingRoute,
});

function PricingRoute() {
	return <PricingPage />;
}
